import { Layout } from 'components'
import { CurrentUserContextProvider } from 'context'
import { ResourceArticleContent } from './ResourceArticleContent'

/** Resource Center article detail (AR-623). Keeps the standard app sidebar. */
export const ResourceArticlePage = () => {
  return (
    <CurrentUserContextProvider>
      <Layout>
        <ResourceArticleContent />
      </Layout>
    </CurrentUserContextProvider>
  )
}
